export const DEFAULT_LANGUAGE = 'en'
// TODO make dynamic again someday
const langsSource = {
    en: {
        label: 'English',
        code: 'en-GB',
    },
    nl: {
        label: 'Nederlands',
        code: 'nl-NL',
    },
    de: {
        label: 'Deutsch',
        code: 'de-DE',
    },
    fr: {
        label: 'Français',
        code: 'fr-FR',
    },
    pl: {
        label: 'Polski',
        code: 'pl-PL',
    },
    da: {
        label: 'Dansk',
        code: 'da-DK',
    },
    it: {
        label: 'Italiano',
        code: 'it-IT',
    },
    es: {
        label: 'Español',
        code: 'es-ES',
    },
}

const supportedLanguages =
    Object.entries(langsSource)?.map((lang) => {
        return {
            locale: lang[0],
            ...lang[1],
        }
    }) || []

const createISOmap = (makeLowercase = false, skipCountries = []) => {
    let isoMap = {}

    supportedLanguages.map((lang) => {
        let code = lang.code
        if (makeLowercase) {
            code = code.toLowerCase()
        }
        if (skipCountries.includes(lang.locale)) {
            code = code.split('-')[0]
        }
        isoMap[lang.locale] = code
    })

    return isoMap
}

export const DEFAULT_LANGUAGE_ISO_CODE = supportedLanguages[DEFAULT_LANGUAGE]
export const LANGUAGES = supportedLanguages.map((lang) => lang.locale)
export const LANGUAGES_WITHOUT_DEFAULT = LANGUAGES.filter((lang) => lang !== DEFAULT_LANGUAGE)

export const LANGUAGE_ISO_CODES = createISOmap()
export const LANGUAGE_ISO_CODES_LOWERCASE = createISOmap(true)
export const LANGUAGE_ISO_CODES_BACKOFFICE = createISOmap(false, ['en', 'nl'])
export const LANGUAGES_IN_PICKER = supportedLanguages

export const HOMEPAGE_LOCALE_URLS = LANGUAGES.flatMap((lang) => {
    if (lang === DEFAULT_LANGUAGE) return '/'
    return [`/${lang}`, `/${lang}/`]
})
/**
 * Get the proper locale code since there mixed up in our code.
 *
 * @param {string} locale
 * @returns {string}
 */
export function localeToI18nLocale(locale) {
    return LANGUAGE_ISO_CODES?.[locale] || DEFAULT_LANGUAGE_ISO_CODE
}
